import React from 'react';
import styled from 'styled-components';
import { IconSmallSearchLegacy } from '@prezi/common-design';

import { Input } from '../../';

type Props = {
    placeholder?: string;
    noMatchAlert?: string | JSX.Element;
    onChange: (value: string) => void;
};

const Search = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    background-color: ${({ theme }) => theme.bento.colors.background.weak};
`;

const SearchInput = styled(Input)`
    padding-left: 32px;
    margin: 8px;
    width: unset;
    flex: 1 1 auto;
    border: 1px solid ${({ theme }) => theme.bento.colors.border.main};
`;

const SearchIcon = styled(IconSmallSearchLegacy)`
    position: absolute;
    top: 50%;
    left: 0;
    margin-left: 12px;
    transform: translateY(-50%);
`;

const NoMatch = styled.div`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 14px;
    background-color: ${({ theme }) => theme.bento.colors.background.weak};
    padding: 16px;
`;

export const DropdownSelectSearch = React.memo(({ placeholder, noMatchAlert, onChange }: Props) => {
    return (
        <>
            <Search>
                <SearchInput
                    placeholder={placeholder}
                    onClick={e => e.stopPropagation()}
                    onChange={e => onChange(e.currentTarget.value)}
                />
                <SearchIcon />
            </Search>
            {typeof noMatchAlert === 'string' ? <NoMatch>{noMatchAlert}</NoMatch> : noMatchAlert}
        </>
    );
});
